<!--
상품을 발송처리 한다.
------------------------------------
-->
<template>
    <!-- 폼 화면 -->
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxxlarge">

            <div class="uk-modal-header">
                <h4 class="uk-text-center">발송요청서 작성</h4>
            </div>

            <div class="uk-modal-body uk-padding-remove uk-flex uk-flex-between uk-child-width-1-2 uk-flex-stretch">

                <!-- 상품정보 표시 -->
                <div class="uk-flex p-2rem" style="border-right: 1px solid #eee">
                    <div class="uk-width-auto uk-text-center">
                        <div class="uk-margin-right">
                            <img
                                :src="prod.img_url"
                                width="100"
                            />

                            <!-- 라벨표시 -->
                            <div class="uk-margin-top">
                                <span v-show="prod.lock_error" class="uk-label uk-label-danger">오류</span>
                                <span v-show="prod.lock_hold" class="uk-label uk-label-danger">보류중</span>
                            </div>
                        </div>

                    </div>
                    <div class="uk-width-expand">

                        <app-column
                            class="uk-margin-small-bottom"
                            header="배송단계"
                            header-size="medium"
                            body-size="medium"
                            header-align="left"
                            body-align="left"
                            horizontal
                            header-width="80px"
                        >
                            {{ prod.state_text }}
                        </app-column>


                        <app-column
                            class="uk-margin-small-bottom"
                            header="상품번호"
                            header-size="medium"
                            body-size="medium"
                            header-align="left"
                            body-align="left"
                            horizontal
                            header-width="80px"
                        >
                            {{ prod.id }}
                        </app-column>

                        <app-column
                            class="uk-margin-small-bottom"
                            header="상품명"
                            header-size="medium"
                            body-size="medium"
                            header-align="left"
                            body-align="left"
                            horizontal
                            header-width="80px"
                        >
                            {{ prod.name }}
                        </app-column>

                        <app-column
                            class="uk-margin-small-bottom"
                            header="색상"
                            header-size="medium"
                            body-size="medium"
                            header-align="left"
                            body-align="left"
                            horizontal
                            header-width="80px"
                        >
                            {{ prod.color }}
                        </app-column>

                        <app-column
                            class="uk-margin-small-bottom"
                            header="사이즈"
                            header-size="medium"
                            body-size="medium"
                            header-align="left"
                            body-align="left"
                            horizontal
                            header-width="80px"
                        >
                            {{ prod.size }}
                        </app-column>



                        <app-column
                            class="uk-margin-small-bottom"
                            header="보관장소"
                            header-size="medium"
                            body-size="medium"
                            header-align="left"
                            body-align="left"
                            horizontal
                            header-width="80px"
                        >
                            {{ prod.storage }}
                        </app-column>

                        <app-column
                            class="uk-margin-small-bottom"
                            header="수량"
                            header-size="medium"
                            body-size="medium"
                            header-align="left"
                            body-align="left"
                            horizontal
                            header-width="80px"
                        >
                            {{ prod.amount }}
                        </app-column>

                    </div>
                </div>


                <!-- 입력 -->
                <div class="p-2rem" >

                    <app-input-ex
                        v-if="! fixedReqMemo"

                        class="uk-margin-small-bottom"
                        type="textarea"
                        :textarea-rows="5"
                        label="label"

                        v-model="inputs.req_memo"
                        placeholder="작업자가 요청사항을 이해하기 쉽게 작성하세요"
                    >
                        <div slot="label" class="bg-yellow font-size-1d125rem" style="text-decoration: underline">발송작업 요청사항 아래에 메모작성</div>
                    </app-input-ex>


                    <app-input-ex
                        v-if="fixedReqMemo"

                        class="uk-margin-small-bottom"
                        type="textarea"
                        :textarea-rows="5"
                        label="label"

                        readonly
                        :value="fixedReqMemo"
                    >
                        <div slot="label" class="bg-yellow font-size-1d125rem" style="text-decoration: underline">발송작업 요청사항 아래에 메모작성</div>
                    </app-input-ex>

                    <label>
                        <input
                            class="uk-checkbox"
                            type="checkbox"
                            v-model="noCheckingJob"
                            @input="changePass()"
                        />
                        무검수 발송
                    </label>

                    <div class="uk-margin-top">
                        * [무검수발송]을 선택하시면, <b>추가 검수 없이 출고</b>하게 됩니다.
                    </div>

                    <div v-if="prod.lock_error" class="uk-margin-top">
                        * <span class="uk-text-bold uk-text-danger">오류상품 발송요청시 [무검수 발송]이 자동 선택</span>됩니다.<br />
                        추가 검수를 원하시는 경우는 [무검수 발송] 선택 해지 하시고,<br />
                        발송작업 요청사항에 간단히 글 남겨 주시기 바랍니다.
                    </div>

                </div>
            </div>


            <div class="uk-modal-footer uk-text-right">
                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>
                <button
                    type="button"
                    class="uk-button uk-button-primary"
                    v-on:click="submit()"
                >
                    <span uk-icon="icon: check"></span>
                    발송요청(완료)
                </button>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,


        },
        data: function () {
            return {
                // (object) 상품정보
                prod: {},

                /**
                 * 입력값
                 */
                inputs: {},


                /**
                 * (bool)
                 * 무검수발송 옵션
                 * - true : 무검수발송
                 * - false : 검수
                 */
                noCheckingJob: false,
            };
        },
        computed: {
            /**
             * 고정된 요청사항(무검수발송 옵션이 선택된경우)
             * @return string
             */
            fixedReqMemo() {
                if (this.noCheckingJob) {
                    return "(무검수 발송)\n\n오류내용 확인했으니 그대로 발송해주세요";
                }

                return null;
            }
        },
        methods: {
            /**
             * 입력폼 display
             */
            displayForm() {

                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             * @param prod_id 상품ID
             */
            form(prod_id) {

                // 초기화
                this.inputs = {
                    req_memo: null,
                };

                // promise 생성
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/prods/' + prod_id,
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.prod = response.prod;

                    // 무검수옵션 기본값설정
                    if (this.prod.lock_error) {
                        this.noCheckingJob = true;
                    }

                    // 폼띄우기
                    this.displayForm();
                });
            },

            /**
             * submit
             */
            submit() {

                // promise 생성
                let load = new Promise((resolve, reject) => {

                    // 파라메터
                    let params = _.merge({
                        '_token': this.csrfToken,
                    }, this.inputs);
                    if (this.fixedReqMemo) {
                        params = _.merge(params, {
                            'req_memo': this.fixedReqMemo,
                        });
                    }

                    // ajax 옵션
                    let opts = {
                        type: 'post',
                        url: '/prods/' + this.prod.id + '/out-requests',
                        data: params,
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });

                // promise 처리
                load.then((response) => {
                    UIkit.modal.alert(response.msg).then(() => {
                        $.app.move('/prods/' + this.prod.id + '/out-req-info');
                    });
                });
            },

        },
    }
</script>

<style lang="scss" scoped>
</style>